import { render } from "./AssignmentTypes.vue?vue&type=template&id=887d5792"
import script from "./AssignmentTypes.vue?vue&type=script&lang=js"
export * from "./AssignmentTypes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__